import { Link } from 'react-router-dom';
import styles from './InformacionLogistica.module.css';

export default function InformacionLogistica() {
  return (
    <div className={styles.page}>
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <div className={styles.logoWrapper}>
            <div className={styles.logoCircle}>
              <img
                src={`${process.env.PUBLIC_URL}/logo.gif`}
                alt="4° MasterClass EPI - Juntos Transformando Vidas"
                className={styles.logoImg}
              />
            </div>
          </div>
          <h1 className={styles.titulo}>Información logística</h1>
          <Link to="/" className={styles.botonVolver}>
            Volver al inicio
          </Link>
        </div>
      </section>

      <section className={styles.content}>
        <div className={styles.imageWrapper}>
          <img
            src={`${process.env.PUBLIC_URL}/informacion-logistica.png`}
            alt="Aspectos logísticos - 4° MasterClass EPI"
            className={styles.logisticaImg}
          />
        </div>
      </section>

      <section className={styles.frase}>
        <div className={styles.fraseContent}>
          <img
            src={`${process.env.PUBLIC_URL}/frase.gif`}
            alt="Más de una década de evidencia, más de un siglo de innovación"
            className={styles.fraseImg}
          />
        </div>
      </section>
    </div>
  );
}
